import './index.scss'
// 点击打开导航栏
let $menuEl = $('.comp-menu')
let $openMenuElArr = $('[data-open="menu"]')
let $logo1 = $('.comp-header-logo .logo1')
let $logo2 = $('.comp-header-logo .logo2')
let $headbac = $('.comp-header')
$openMenuElArr.click(function () {
	if (this.classList.value.indexOf('sp_nav_se') >= 0) {
		$headbac.removeClass('whitecolor')
		$openMenuElArr.removeClass('active')
		$menuEl.removeClass('active')
		$('.hamburger-1').removeClass('sp_nav_se');
		$logo1.show()
		$logo2.hide()
	} else {
		$headbac.addClass('whitecolor')
		$openMenuElArr.addClass('active')
		$menuEl.addClass('active')
		$('.hamburger-1').toggleClass('sp_nav_se');
		$logo2.show()
		$logo1.hide()
	}
})

// 点击打开二级栏目
$('.comp-menu-nav ul li i').click(function () {
	$(this).parent().children('ul').slideToggle().parent().siblings().children('ul').slideUp();
	$(this).toggleClass('active_icon');
	$(this).parent().siblings().find('i').removeClass('active_icon');
});

$('.comp-menu-wrapper-search').bind("click", function () {
	$(this).addClass("active").siblings().removeClass("active");
});